<template>
    <CInputGroup>
        <slot />
    </CInputGroup>
</template>

<script>
import { CInputGroup } from '@coreui/vue-pro'

export default {
    name: 'DInputGroup',
    components: { CInputGroup }
}
</script>
